import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'delete-org-unit-confirm',
    template: `
    <div class="modal-header">
      <h4 class="modal-title">Delete Org Unit?</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close('Cross click')" ></button>
    </div>
    <div class="modal-body">
      <p>Are you sure want to delete the org unit: {{name}}?</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="activeModal.close('Yes click')">Yes</button>
      <button type="button" class="btn btn-default" (click)="activeModal.dismiss('No click')">No</button>
    </div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteOrgUnitConfirmComponent {
  @Input() name: string;

  constructor(public activeModal: NgbActiveModal) {
  }
}
